import { type FieldValues } from '@restore/dynamic-forms';
import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';

export const submitForm = async (
  realm: string,
  formId: string,
  uuid: string,
  formData: FieldValues
): Promise<boolean> => {
  const body = {
    webhookUuid: uuid,
    submissionResponses: formData,
  };

  const token = await getAccessToken();
  return fetch(`${baseApiUrl}/document/form/submit/${formId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'x-tenant-id': realm,
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (response.status === 200) {
        return true;
      }

      return false;
    })
    .catch((error) => {
      throw Error(`Error fetching form fields: ${error}`);
    });
};
